import React from 'react';
import {AiOutlineHeart} from 'react-icons/ai'

const data = [`Whether formally dressed or in casuals, your style should always be `,

`It is very comfortable and uniquely designed.`,

`The soft, comfortable and breathable material gives your leg room. 
`];

const sizes = [ `12`, `14`, `16`, `18`, `20`, `22`, `24`];


const ProductInfo = ({name,price,qty}) => {


  return (
        <div className="container mx-auto md:px-4">
          <div className="w-full ">
          <h3 className="text-black w-full self-start text-3xl font-bold">{name}</h3>
            </div>
            <div>
              {
                data.map((item,index) => (
                  <p className="truncate text-black self-start" key={index}>{item}</p>
                ))
              }
            </div>
            <div className="mt-4">
              <h1 className="text-black w-full self-start text-3xl font-bold">#{price}</h1>
              </div>
              <div className="mt-4 flex space-x-4">
              <div className="flex border-2 space-x-6 justify-between px-2  h-8 ">
                  <button className="outline-none border-none ">-</button>
                <p className="text-black mr-8">1</p>
             
                <button className="outline-none border-none ml-8"  >+</button>
                {/* end of cart btn */}
            </div>
            <div className="mb-4">
            <button className="font-bold text-white bg-tradr-green text-sm px-8 py-1 "  
            >
                Add to Cart
              </button>
            </div>
            </div>
            <div className="flex flex-col">
            <p className="text-ash opacity-70 text-sm">
              size 
              </p>
              <div className="flex space-x-2">
              {
                sizes.map((item,index) => (
                  <p className="text-black text-base p-2 cursor-pointer hover:bg-tradr-green hover:text-white border-ash border-2" key={index}>{item}</p>
                ))
              }

          </div>
          <div className="flex space-x-2">

          </div>
          </div>
          </div>

  );
}

export default ProductInfo